// Modules
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const GroupActive = styled.div`
    max-width: 220px;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #4c5564;
    font-size: 14px;
    white-space: nowrap;
`;

function Active(props) {
  return (
    <GroupActive data-testid="active">
      <FontAwesomeIcon
        icon={['fal', 'layer-group']}
        style={{ fontSize: '12px', marginRight: '8px', marginBottom: '1px' }}
      />
      {props.name}
    </GroupActive>
  );
}

Active.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Active;
